import { Box, Stack } from '@mui/material';
import { Accordion } from 'common';
import { PropsWithChildren } from 'react';

interface StackWithAccordionProps
    extends PropsWithChildren<{ title: string; testId: string; defaultExpanded?: boolean }> {}

export const StackWithAccordion = ({ title, children, testId, defaultExpanded = true }: StackWithAccordionProps) => {
    return (
        <Box data-testid={testId} width="100%">
            <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                <Accordion
                    title={title}
                    variant="transparent"
                    defaultExpanded={defaultExpanded}
                    typographyProps={{ variant: 'subtitle1' }}
                    sx={{ width: '100%' }}
                >
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={2}
                        width="100%"
                    >
                        {children}
                    </Stack>
                </Accordion>
            </Stack>
        </Box>
    );
};
